import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { InvoiceTicket } from '../models/invoice-ticket';
import { Observable } from 'rxjs';
import { GasTravel } from '../models/gas-travel';

@Injectable({
  providedIn: 'root'
})
export class InvoiceTicketService {

  constructor(private http: HttpClient) { }

  getInvoiceTicket(): Observable<InvoiceTicket[]>{
    return this.http.get<InvoiceTicket[]>('/api/invoice-ticket');
  }

  saveInvoiceData(invoiceTicket: InvoiceTicket): Observable<InvoiceTicket>{
    return this.http.post<InvoiceTicket>('/api/invoice/ticket', invoiceTicket);
  }

  getSelectedTickets(tickets: String[]): Observable<GasTravel[]>{
    return this.http.get<GasTravel[]>('/api/get/selected/invoice-tickets', {params:{'data': JSON.stringify(tickets)}});
  }

  associateTicketsToInvoices(ticketToAssociate: GasTravel[], invoice: InvoiceTicket): Observable<InvoiceTicket[]>{
    return this.http.get<InvoiceTicket[]>('/api/associate/invoice-tickets', {params:{'tickets': JSON.stringify(ticketToAssociate), 'invoice': JSON.stringify(invoice)}});
  }

  cancelInvoiceTickets(invoice: InvoiceTicket): Observable<InvoiceTicket[]>{
    return this.http.post<InvoiceTicket[]>('/api/invoice-tickets/' + invoice.id + '/cancel', {});
  }

  updateDataInvoiceTickets(invoice: InvoiceTicket): Observable<InvoiceTicket[]>{
    return this.http.post<InvoiceTicket[]>('/api/invoice-tickets/update', invoice);
  }

  removeInvoiceTickets(associatedTickets: GasTravel[], invoice: InvoiceTicket): Observable<InvoiceTicket[]>{
    return this.http.get<InvoiceTicket[]>('/api/remove/invoice-tickets', {params:{'tickets': JSON.stringify(associatedTickets), 'invoice': JSON.stringify(invoice)}});
  }
}
